/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';
import { FixDocumentUpdateDto } from '../../models/fix-document-update-dto';

export interface FixDocumentControllerUpdate$Params {

/**
 * 센터 아동 ID
 */
  ticketId: string;

/**
 * 문서 ID
 */
  documentId?: string;
      body: FixDocumentUpdateDto
}

export function fixDocumentControllerUpdate(http: HttpClient, rootUrl: string, params: FixDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
  const rb = new RequestBuilder(rootUrl, fixDocumentControllerUpdate.PATH, 'post');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
    rb.query('documentId', params.documentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDto>;
    })
  );
}

fixDocumentControllerUpdate.PATH = '/api/fix-document';
